<template>
  <div class="content">
    <div class="head">
      <!-- <Head :nub="nub"></Head> -->
    </div>
    <div style="position: fixed;right:10px;top:300px;z-index:1000">
      <Rightnav @showsp="getshow" @runtops="runtop"></Rightnav>
    </div>
    <transition name="slide-fade">
      <div class="Mask wow slideInUp" data-wow-duration="0.7s" data-wow-offset="2" v-if="showquote">
        <div class="mask-main">
          <i @click="mask" class="iconfont icon-guanbi"></i>
          <Freequote> </Freequote>
        </div>
      </div>
    </transition>
    <div class="carousel">
      <div class="carousel_one">
        <el-carousel height="600px">
          <el-carousel-item v-for="(item,index) in msg3" :key="index">
            <img :src="item.imgurl" />
          </el-carousel-item>
        </el-carousel>
        <div class="Location" hidden-md-and-down>
          <div class="Location_main">
            <el-form ref="form" :model="ruleForm" label-width="80px">
              <el-form-item label="姓名">
                <el-input v-model="ruleForm.names" placeholder="请输入您的称呼"></el-input>
              </el-form-item>
              <el-form-item label="电话号码">
                <el-input v-model="ruleForm.phones" placeholder="填写手机号码，0元获取全屋设计方案"></el-input>
              </el-form-item>
              <el-form-item label="选择地址">
                 <Tpicker @citydata="getcitydata"></Tpicker>
              </el-form-item>
              <el-button @click="ReservationDesign">免费预约设计</el-button>
            </el-form>
          </div>
        </div>
      </div>
      <HeadMenu></HeadMenu>
      <Setmeal></Setmeal>
      <Decorationcases></Decorationcases>
      <designer></designer>
      <Aboutus></Aboutus>
      <brand></brand>
      <Decoration></Decoration>
    </div>
    <div class="btnmargin">
      <BottomFoot></BottomFoot>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import swiper from "swiper";
// import Head from "../components/Head.vue";
import BottomFoot from "../components/BottomFoot.vue";
import Rightnav from "../components/Rightnav.vue";
import Freequote from "../components/Freequote.vue";
import BookingDecoration from "../components/appointment/BookingDecoration.vue";
import QuantityRoom from "../components/appointment/QuantityRoom.vue";
import HeadMenu from "../components/indexc/HeadMenu.vue";
import Setmeal from "../components/indexc/Setmeal.vue";
import Decorationcases from "../components/indexc/Decorationcases.vue";
import designer from "../components/indexc/designer.vue";
import Aboutus from "../components/indexc/Aboutus.vue";
import brand from "../components/indexc/brand.vue";
import Decoration from "../components/indexc/Decoration.vue";
import WOW from "wowjs";
import VDistpicker from "v-distpicker";
import Tpicker from "../components/Tpicker.vue";
export default {
  components: {   
    // Head,
    Tpicker,
    BottomFoot,
    Rightnav,
    Freequote,
    BookingDecoration,
    QuantityRoom,
    VDistpicker,
    HeadMenu,
    Setmeal,
    Decorationcases,
    designer,
    Aboutus,
    brand,
    Decoration
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "description",
          content:
            "厦门金牌桔家云整装科技有限公司成立于2018年，总部位于厦门市同安区，由A股上市企业金牌厨柜出品，自主研发的“桔家云整装”信息系统，全面整合国内外优质建材、家具、软装等品牌供应商资源，一键打通设计、订单、生产、物流、仓储、安装、施工监控等泛家装各环节，为全国装企、设计师、施工队等组织赋能，向家装业主提供更全面、更高效、更优质的整体家装解决方案。"
        },
        {
          name: "keywords",
          content:
            "桔家云整装官网，桔家云整装，桔家云，整装，全包，装修，毛坯装修，全屋定制，拎包入住，金牌厨柜，桔家衣柜，桔家木门"
        }
      ]
    };
  },
  data() {
    return {
      form: {
        namel: "",
        numberl: ""
      },
      show2: false,
      ruleForm: {
        names: "",
        phones: "",
        address: "",
        measure: "",
        region: ""
      },
      nub: "1",
      show: false,
      msg2: [],
      msg3: [
        { imgurl: require("../assets/images/banner.jpg"), name: "1" },
        { imgurl: require("../assets/images/index/banner-2.jpg"), name: "2" },
        { imgurl: require("../assets/images/index/banner-3.jpg"), name: "3" },
        { imgurl: require("../assets/images/index/banner-4.jpg"), name: "4" },
      ],
      showquote: false,
      formtitle: [{ title: "免费量房申请" }],
      cur: 0,
      msg: [
        {
          imgurl: require("../assets/images/index/case1.png"),
          id: "CS00000000000016",
          text:
            "家居装修是指对房屋的整体布局、风格、色彩及空间使用的重新设定，分为传统家装和互联网家装。"
        },
        {
          imgurl: require("../assets/images/index/case2.png"),
          id: "CS00000000000013",
          text: "家居装修风格有现代装修风格，欧式装修风格。"
        },
        {
          imgurl: require("../assets/images/index/case4.jpg"),
          id: "3FO4HDOQKVQP",
          text:
            "现代装修风格分为：现代风格、现代简约风格和极简风格，欧式装修风格分为：北欧、传统欧式、简欧。美式装修风格分为：传统美式风格、乡村风格,而田园装修风格是以以象牙白、米色为主的装修风格。"
        },
        {
          imgurl: require("../assets/images/index/case3.jpg"),
          id: "3FO4HDQ26B3U",
          text: "家居装修风格还有美式装修风格及其田园装修风格。"
        }
      ],
      setmeal: [
        {
          //599
          id: "45"
        },
        {
          //10899
          id: "54"
        },
        {
          //13999
          id: "51"
        },
        {
          //21599
          id: "52"
        },
        {
          //8999
          id: "53"
        }
      ],
     posdata:[]
    };
  },
  methods: {
       getcitydata(data) {
     
      this.posdata.province = data[0];
      this.posdata.city = data[1];
      this.posdata.area = data[2];
       console.log("getcitydata", this.posdata);
    },
    onChangeProvince(data) {
      this.ruleForm.clientprovinces = data.value;
    },
    onChangeCity(data) {
      this.ruleForm.clientcitys = data.value;
    },
    onChangearea(data) {
      this.ruleForm.countys = data.value;
    },
    getshow(data) {
      //console.log("data", data);
      this.showquote = data;
    },
    enter(item) {
      item.show = true;
    },

    leave(item) {
      item.show = false;
    },
    mask() {
      this.showquote = false;
    },
    runtop(data) {
      document.documentElement.scrollTop = data;
    },
    todeco(item) {
      this.$router.push({ path: "/HowDeco", query: { resl: item.id } });
    },
  
    todetail(item) {
      this.$router.push({ path: "/DesignerDetails", query: { resl: item.id } });
    },
    tojp() {
      this.$router.push({ path: "/DecorationCase" });
    },
    tosetmealdetail(itemid) {
      this.$router.push({ name: "NewPackagedetails", query: { id: itemid } });
    },
    tosetmeal() {
      this.$router.push({ path: "/Setmeal" });
    },

    todecomethod() {
      this.$router.push({ path: "/DecoMethod" });
    },
    free() {
      this.$router.push({ path: "/NewFreeRegistration" });
    },
 
    toCasedetails(itemid) {
      this.$router.push({ name: "Decorationdetails", query: { id: itemid } });
    },
    toCasedetails2(itemid) {
      this.$router.push({ name: "Casedetails", query: { id: itemid } });
    },
    getpostshejis: async function() {
      let data = {
        area: "",
        city: "厦门市",
        limit: 6,
        page: 1,
        province: "福建省"
      };
      let res = await this.exequy.postshejis(data);
      res.data.data.list.map(vl => {
        vl.show = false;
      });
      this.msg2 = res.data.data.list;
    },
    ReservationDesign: async function() {
      if (this.ruleForm.names == "") {
        this.$message({
          message: "姓名不能为空",
          type: "warning"
        });
        return false;
      }
      if (this.ruleForm.phones == "") {
        this.$message({
          message: "电话号码不能为空",
          type: "warning"
        });
        return false;
      }
      if (/^1[3-9]\d{9}$/.test(this.ruleForm.phones) == false) {
        this.$message({
          message: "电话号码格式不正确",
          type: "warning"
        });
        return false;
      }
      if(this.posdata.province == undefined){
         this.$message({
          message: "请选择省市区",
          type: "warning"
        });
        return false;
      }
      let data = {
        clientcity: this.posdata.city,
        clientname: this.ruleForm.names,
        clientprovince:  this.posdata.province,
        county: this.posdata.area,
        moblephone: this.ruleForm.phones,
        source: "1",
        registertype: "1"
      };
      let res = await this.exequy.appointment(data);
      console.log("res", res);
      if (res.data.code == 0) {
        this.$message({
          message: "预约成功",
          type: "success"
        });
      } else {
        this.$message({
          message: "预约失败",
          type: "warning"
        });
      }
    },
    todesign() {
      this.$router.push({ path: "/Designer" });
    },
      locations() {
      //判断屏幕宽度
        var winWide = window.screen.width;  //获取当前屏幕分辨率
        var wideScreen = false;
        if (winWide <=600) {  //600及以下分辨率
            window.location.href = "https://m.ghomecloud.com/#/index2";//加载index1.html
        } else {  //大于600的分辨率
            window.location = "https://www.ghomecloud.com/#/";//加载index2.html
        }
    },
  },
  mounted() {
    this.$router.afterEach((to, from, next) => {
      window.scrollTo(0, 0);
    }),
      new WOW.WOW().init();
    new swiper(".swiper-container", {
      slidesPerView: 3,
      spaceBetween: 30,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
    let myswiper = new swiper(".swiper-container2", {
      speed: 700,
      slidesPerView: "auto",
      centeredSlides: true,
      allowTouchMove: false,
      on: {
        init: function() {
          this.slides.removeClass("init");
        }
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
      }
    });
    console.log("swiper.$el", myswiper);

    // myswiper.$el.parent(".apple-retail")[0].onmouseover = function() {
    //   myswiper.$el.addClass("mouse-hover");
    // };
    // myswiper.$el.parent(".apple-retail")[0].onmouseout = function() {
    //   myswiper.$el.removeClass("mouse-hover");
    // };
  },
  created() {
    const self = this;
    // self.locations()
  }
};
</script> 
<style scoped>
.content {
  width: 100%;
}
.swiper-wrapper {
  height: 650px;
}
.inner >>> .gallery-item-desc {
  padding-top: 0px;
}
.head {
  width: 100%;
  overflow: hidden;
  position: fixed;
  top: 0;
  z-index: 1000;
}
.main {
  width: 1340px;
  margin: 0 auto;
}
.carousel {
  position: relative;
  
}
.carousel >>> .el-carousel__arrow--left {
  left: 60px;
}
.carousel >>> .el-carousel__arrow--right {
  right: 60px;
}
.carousel >>> .el-carousel__arrow {
  height: 70px;
  width: 70px;
  font-size: 35px;
}
.btn {
  width: 15%;
  font-size: 14px;
  float: right;
  height: 2rem;
  line-height: 2rem;
  background: #b31d25;
  color: #fff;
  border-radius: 2px;
  margin-top: 1.2rem;
  cursor: pointer;
}
.el-carousel__item img {
  width: 100%;
  height: 100%;
  margin: 0;
}
.el-carousel__item {
  height: 600px;
}
.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

.iconfont {
  font-size: 40px;
  color: #b31d25;
}
.Design-one {
  display: flex;
  justify-content: space-around;
  padding-top: 40px;
}
.designertext {
  font-size: 14px;
  padding: 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.Designer-show img {
  height: 100%;
  width: 100%;
}
.Designer-show {
  width: 200px;
  height: 200px;
  position: relative;
  transition: all 0.6s;
}
.Designer-show:hover {
  transform: scale(1.1);
}
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.6s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active for below version 2.1.8 */ {
  transform: translateY(5px);
  opacity: 0;
}
.picture-Mask {
  width: 100%;
  height: 50%;
  background: rgba(63, 63, 63, 0.514);
  position: absolute;
  bottom: 5px;
}
.picture-Mask2 {
  width: 100%;
  height: 150px;
  position: absolute;
  font-size: 15px;
  bottom: -140px;
}
.picture-Mask2 > div {
  width: 50%;
  height: 25px;
  line-height: 25px;
  font-size: 15px;
}
.picture-Mask2 div:first-child {
  float: left;
  cursor: pointer;
  background: #b31d25;
  color: #fff;
}
.picture-Mask2 div:last-child {
  float: right;
  cursor: pointer;
  background: #fff;
  color: #000;
}
.picture-Mask > p {
  width: 80%;
  font-size: 19px;
  line-height: 2.3rem;
  color: #fff;
  text-align: center;
  margin: 0 auto;
  border-bottom: 1px solid #fff;
}
.picture-Mask > div {
  font-size: 15px;
  width: 100%;
  margin-top: 5px;
  color: #fff;
}
.brand {
  width: 100%;
}
.brand img {
  width: 100%;
}
.carousel_one {
  position: relative;
}
.carousel_one >>> .el-carousel__indicators--horizontal {
  bottom: 45px;
}
.Location {
  width: 1280px;
  height: 90px;
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0px 8px 13px 0px rgba(1, 1, 1, 0.16);
  border-radius: 10px;
  margin-top: -45px;
  position: relative;
  z-index: 100;
}
.Location_main {
  width: 100%;
  margin: 0 auto;
  display: flex;
}
.Location_main >>> .el-form {
  width: 100%;
  height: 90px;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.Location_main >>> .el-form-item {
  width: 25%;
  margin-bottom: 0px;
}
.Location_main >>> .el-button--default {
  width: 20%;
  height: 60px;
  color: #fff;
  margin-left: 4%;
  background-image: linear-gradient(
    135deg,
    #d71a1c 0%,
    #ee1012 41%,
    #bc001d 100%
  );
}
.Mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1000;
}
.mask-main {
  border-radius: 15px;
  text-align: center;
  width: 50%;
  height: 60%;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  background-color: white;
  z-index: 10000;
}
.icon-guanbi {
  font-size: 25px;
  position: absolute;
  right: 11px;
  top: 5px;
  line-height: normal;
}

.set-title {
  display: flex;
  margin: 2rem 0;
  width: 100%;
}

.titletext {
  display: flex;
}
.strip {
  width: 5px;
  height: 40px;
  background: #b31d25;
}
.titlecn {
  font-size: 30px;
  color: #303133;
  margin-left: 15px;
}
.titleen {
  font-size: 25px;
  line-height: 43px;
  color: #303133;
  margin-left: 15px;
}
.Setmeal-main {
  display: flex;
}
.bigpicture {
  width: 50%;
  height: 592px;
  cursor: pointer;
}
.bigpicture img {
  width: 100%;
  height: 100%;
}
.Smallgraph {
  width: 55%;
  height: 592px;
  display: flex;
  flex-wrap: wrap;
}
.Smallgraph-main {
  width: 45%;
  height: 292px;
  margin-left: 5%;
  cursor: pointer;
}
.Smallgraph-main img {
  width: 100%;
  height: 100%;
}
.Boutique {
  width: 100%;
  height: 500px;
}
.Boutique-main {
  display: flex;
  height: 100%;
}
.Boutique-main img {
  width: 100%;
  height: 100%;
}
.Boutique-left {
  width: 50%;
  cursor: pointer;
}
.Boutique-right {
  position: relative;
  width: 50%;
  cursor: pointer;
}
.Twograph {
  display: flex;
  width: 100%;
  height: 40%;
}
.Twograph-left {
  position: relative;
  width: 50%;
  height: 96%;
  margin: 0 1% 1% 0;
  cursor: pointer;
}
.Twograph-right {
  position: relative;
  width: 48%;
  height: 96%;
  margin: 0 1% 1% 0;
  cursor: pointer;
}
.onegraph {
  width: 99%;
  height: 60%;
  margin: 0 1% 1% 0;
  cursor: pointer;
  position: relative;
}

.Boutique-right .maskkk {
  height: 21%;
}
.onegraph .maskkk {
  height: 25%;
}
.maskkk {
  width: 100%;
  height: 40%;
  position: absolute;
  bottom: 0;
  color: #fff;
  text-align: left;
  background: rgba(63, 63, 63, 0.514);
}
.maskkk p {
  margin: 15px 15px;
  line-height: 1.7rem;
}

.right-main-text {
  width: 49%;
  margin-left: 1%;
}
.Design-swiper {
  width: 100%;
  height: 280px;
  background: #c2c2c22c;
}
.apple-retail {
  margin: 30px 0;
  position: relative;
}
.apple-retail >>> .swiper-slide {
  text-align: center;
  padding: 0 calc((100vw - 816px) * 0.15);
  width: 816px;
}
.inner figure {
  width: 100%;
}
.inner figure img {
  width: 100%;
  border-radius: 6px;
}
.gallery-item-desc {
  width: 80%;
  text-align: left;
  display: inline-block;
  padding-top: 46px;
  opacity: 0;
  transition-duration: 1.2s;
}
.init .gallery-item-desc {
  opacity: 1;
}
.bottomsign {
  display: flex;
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 80px;
  background: rgba(30, 30, 31, 0.8);
  z-index: 100;
  align-items: center;
}
.ReservationDesign {
  color: #fff;
  width: 120px;
  height: 40px;
  line-height: 40px;
  border-radius: 5px;
  background: #b31d25;
  margin-left: 2rem;
  cursor: pointer;
}
.bottomsign-title {
  width: 35%;
}
.inputsbum {
  display: flex;
  width: 65%;
}
.inputsbum >>> .el-input {
  width: 20%;
  margin-left: 15px;
}
.inputsbum >>> .distpicker-address-wrapper {
  margin-left: 15px;
}
.gallery-item-desc h3 {
  line-height: 1.16667;
  font-weight: 600;
  letter-spacing: 0.009em;
  color: #111;
  font-size: 20px;
}
.gallery-item-desc p {
  margin-top: 1em;
  color: #333;
  font-size: 15px;
}
.swiper-slide-prev .gallery-item-desc {
  transform: translateX(-70px);
}
.swiper-slide-next .gallery-item-desc {
  transform: translateX(70px);
}
.swiper-slide-active .gallery-item-desc {
  opacity: 1;
  transform: translateX(0);
}
@media only screen and (max-width: 1068px) {
  .apple-retail >>> .swiper-slide {
    padding: 0 calc((100vw - 576px) * 0.15);
    width: 576px;
  }
  .gallery-item-desc {
    padding-top: 41px;
  }
}
@media only screen and (max-width: 735px) {
  .apple-retail >>> .swiper-slide {
    transform: scale(0.9);
    padding: 0;
    width: 85vw;
    margin: 0 0;
    min-width: 272px;
  }
  .apple-retail >>> .swiper-slide-active {
    transform: scale(1);
  }
  .gallery-item-desc {
    padding-top: 26px;
    width: 90%;
  }
}
.swiper-button-next,
.swiper-button-prev {
  top: 40%;
  background-color: rgba(210, 210, 210, 0.6);
  background-size: 15px 15px;
  border-radius: 50%;
  width: 52px;
  height: 52px;
  transition: all 0.5s;
  outline: none;
  opacity: 0;
}
.mouse-hover .swiper-button-next,
.mouse-hover .swiper-button-prev {
  opacity: 1;
}
.swiper-button-next:hover,
.swiper-button-prev:hover {
  background-color: rgba(210, 210, 210, 0.8);
}
.swiper-button-next {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  right: 20px;
}
.swiper-button-prev {
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E");
  left: 20px;
}
.swiper-container .swiper-button-next.swiper-button-disabled,
.swiper-container .swiper-button-prev.swiper-button-disabled {
  opacity: 0;
}
</style>
